import React from 'react';
import MusicAlbumInfoReleaseTitleView from './MusicAlbumInfoReleaseTitleView';
import MusicAlbumInfoReleaseTrackRoleView from './MusicAlbumInfoReleaseTrackRoleView';
import MusicAlbumInfoReleaseTrackAuthorView from './MusicAlbumInfoReleaseTrackAuthorView';
import MusicAlbumInfoReleaseTrackTitleView from './MusicAlbumInfoReleaseTrackTitleView';
import MusicAlbumInfoReleaseTrackIsrcView from './MusicAlbumInfoReleaseTrackIsrcView';
import MusicAlbumInfoReleaseTrackDiscountView from './MusicAlbumInfoReleaseTrackDiscountView';

/**
 * リリース情報
 */
export default function MusicAlbumInfoReleaseView({
  musicAlbum,
} : {
  musicAlbum: {
    id: number,
    release_status: number,
    title: string,
    title_kana: string,
    title_en: string,
    image_url: string,
    genre: string,
    tunecore_completed_date: string|null,
    music_album_artists: {
      name: string,
      name_kana: string,
      name_en: string,
    }[],
    music_album_tracks: {
      id: number,
      track_no: number,
      music: {
        id: number,
        title: string,
        title_kana: string,
        title_en: string,
        version: string,
        version_kana: string,
        version_en: string,
        source_audio_url: string,
        is_inst: number,
        remixer_name: string|null,
        remixer_name_en: string|null,
        music_featuring_artists: {
          name: string,
        }[],
        music_lyric_writers: {
          name: string,
          name_en: string,
        }[],
        music_composers: {
          name: string,
          name_en: string,
        }[],
        music_production_and_engineering_roles: {
          id: number,
          role_text: string,
          name: string,
          name_en: string,
        }[],
        music_performance_roles: {
          id: number,
          role_text: string,
          name: string,
          name_en: string,
        }[],
      },
    }[],
  },
}) {
  return (
    <>
      <MusicAlbumInfoReleaseTitleView
        musicAlbum={musicAlbum}
      />
      <div className="song_list">
        {musicAlbum.music_album_tracks.map((musicAlbumTrack) => (
          <div className="song_one" key={musicAlbumTrack.id}>
            <div className="inner">
              <MusicAlbumInfoReleaseTrackTitleView trackNo={musicAlbumTrack.track_no} music={musicAlbumTrack.music} />
              <MusicAlbumInfoReleaseTrackAuthorView music={musicAlbumTrack.music} />
              <MusicAlbumInfoReleaseTrackRoleView music={musicAlbumTrack.music} />
              <MusicAlbumInfoReleaseTrackIsrcView musicAlbum={musicAlbum} music={musicAlbumTrack.music} />
              <MusicAlbumInfoReleaseTrackDiscountView musicAlbum={musicAlbum} music={musicAlbumTrack.music} />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
